import { selectAllStrings } from '../features/language/languageSlice';
import { selectAllReviewIds, fetchAllReviews, selectReviewById, fetchCountReviews } from '../features/reviews/reviewsSlice';
import { selectImageIds, selectImageById, fetchLatestPhotos, fetchCountImages } from '../features/gallery/gallerySlice';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import FeaturedPoisSection from '../features/pois/FeaturedPoisSection';
import TrendingPoisSection from '../features/pois/TrendingPoisSection';
import NewsSection from '../features/news/NewsSection';
import ReviewList from '../features/reviews/ReviewList';
import Navbar from './Navbar';
import Photo from '../features/gallery/Photo';
import '../stylesheets/SocialWallPage.css';
import ImageList from '../features/gallery/ImageList';

const SocialWallPage = () => {
    const strings = useSelector(selectAllStrings);
    const reviewIds = useSelector(selectAllReviewIds);
    const reviewsStatus = useSelector(state => state.reviews.all.status);
    const reviewsError = useSelector(state => state.reviews.all.error);

    const imageIds = useSelector(selectImageIds);
    const galleryStatus = useSelector(state => state.gallery.all.status);
    const galleryError = useSelector(state => state.gallery.all.error);
    const dispatch = useDispatch();
    
    const reviewsPerPage = 10;
    const imagesPerPage = 10;
    
    const totalReviews = useSelector(state => state.reviews.reviewsCount);
    const totalImages = useSelector(state => state.gallery.imagesCount);
    
    const loadingMoreReviews = useSelector((state) => state.reviews.loadingMore);
    const loadingMoreImages = useSelector((state) => state.gallery.loadingMore);
    
    
    const seeMoreReviews = event => {
        event.preventDefault();
        dispatch(fetchAllReviews({limit: reviewsPerPage, buffer: reviewIds.length}));
    };
    const seeMoreImages = event => {
        event.preventDefault();
        dispatch(fetchLatestPhotos({limit: imagesPerPage, buffer: imageIds.length}));
    };

    useEffect(async () => {
        if (reviewsStatus === 'idle') {
            dispatch(fetchAllReviews({limit: reviewsPerPage}));
            dispatch(fetchCountReviews());
        }
        if (galleryStatus === 'idle') {
            dispatch(fetchLatestPhotos({limit: imagesPerPage}));
            dispatch(fetchCountImages());
        }
    }, [dispatch, galleryStatus, reviewsStatus]);

    return <div id="social_wall_page">
        <div className="content">
            <h1>{strings.social_wall_page}</h1>
        </div>
        <FeaturedPoisSection/>
        <TrendingPoisSection/>
        <div className="content">
            <NewsSection/>
            <div className="reviews">
                <h2>{strings.latest_reviews}</h2>
                <ReviewList reviewIds={reviewIds} reviewsStatus={reviewsStatus} reviewsLimit={reviewIds.length} reviewsError={reviewsError} showLink={true} showDate={false} selectById={selectReviewById}
                showControls={true}/>
                {reviewIds.length < totalReviews ? <button className="btn" id="show_more_reviews" onClick={seeMoreReviews}>
                {loadingMoreReviews ? <div className="loader"></div> : strings.see_more}
                </button> : null}
            </div>
            <div className="photos">
                <h2>{strings.latest_photos}</h2>
                {galleryStatus === 'loading' ? <div className="loader"></div> : galleryStatus === 'succeeded' ?
                    <ImageList imageIds={imageIds} imagesLimit={imageIds.length} selectById={selectImageById}/>
                                : <div>{galleryError}</div>}
                {imageIds.length < totalImages ? <button className="btn" id="show_more_images" onClick={seeMoreImages}>
                {loadingMoreImages ? <div className="loader"></div> : strings.see_more}
                </button> : null}

            </div>
        </div>
        <Navbar/>
    </div>
};

export default SocialWallPage;